import React, { useState, useEffect } from 'react';
import styles from './index.scss';

const baseUrl = () => {
  return process.env.NODE_ENV === 'development'
    ? 'https://www.raisestaging.com/www-cms/graphql'
    : '/www-cms/graphql';
};

const CmsBanner = () => {
  const isHeaderTransparent = document
    .getElementsByTagName('header')[0]
    .classList.contains('transparent');
  // Check if closed already from cookie or hide on certain pages
  const hide = !!document.cookie.match(
    /^(.*;)?\s*siteBanner\s*=\s*[^;]+(.*)?$/
  );
  const path = window.location.pathname.toLowerCase();
  const [bannerHidden, hideBanner] = useState(
    hide || !!path.includes('sign_in') ||
      !!path.includes('sign_up') ||
      !!path.includes('email_confirmations') ||
      !!path.includes('login') ||
      !!path.includes('password')
  );
  const [promoData, setPromoData] = useState({});
  const hasBreadCrumbs = !!document.getElementsByClassName('breadcrumb').length;

  const fetchBannerData = async () => {
    try {
      const GRAPHQL_BASE_URL = baseUrl();
      const getParams = {
        query: `{
          getCurrentSitePromoInfo {
            title subtitle startTime endTime imageUrl
            linkTo backgroundColor textColor
          }
        }`,
      };
      const query = Object.keys(getParams)
        .map(k => {
          return `${encodeURIComponent(k)}=${encodeURIComponent(getParams[k])}`;
        })
        .join('&');

      const bannerResponse = await fetch(`${GRAPHQL_BASE_URL}?${query}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
      });

      const bannerData = await bannerResponse.json();
      const { getCurrentSitePromoInfo } = bannerData.data;
      const now = Date.now();
      const start = new Date(getCurrentSitePromoInfo.startTime).getTime();
      const end = new Date(getCurrentSitePromoInfo.endTime).getTime();
      if (now < start || now > end) {
        hideBanner(true);
        return;
      }

      // if the promo is going to end while user is browsing:
      const delay = end - now;

      // Set timeout only allows 32 bit integer
      if (delay < 2147483647) {
        setTimeout(() => {
          const notificationContainer = document.getElementById('flash-container');
          notificationContainer.classList.remove('below-promo');
          hideBanner(true);
        }, delay);
      }

      if (!isHeaderTransparent || hasBreadCrumbs) {
        document.body.style.paddingTop = '100px';
      }

      setPromoData(getCurrentSitePromoInfo);
    } catch (err) {
      // If the fetch for banner data fails
      if (!isHeaderTransparent) document.body.style.paddingTop = '60px';
    }
  };

  useEffect(() => {
    if (!bannerHidden) {
      fetchBannerData();
    }
  }, []);

  const closeDiv = () => {
    if (!isHeaderTransparent || hasBreadCrumbs) {
      document.body.style.paddingTop = '60px';
    }

    const notificationContainer = document.getElementById('flash-container');
    notificationContainer.classList.remove('below-promo');
    hideBanner(true);
  };

  const renderBanner = () => {
    const { backgroundColor, linkTo, title, subtitle, textColor } = promoData;
    const bannerStyle = { backgroundColor, color: textColor };

    return (
      <div className={styles.bannerBuffer} id="cms-promo-banner">
        <div className={styles.banner} style={bannerStyle}>
          <div className={styles.textContainer}>
            <a className={styles.bannerLink} href={linkTo}>
              <p className={styles.bannerTitle}>{title}</p>
              <p className={styles.bannerSubTitle}>{subtitle}</p>
            </a>
          </div>
          <button
            className={styles.bannerButton}
            onClick={() => {
              const currentDate = new Date();
              currentDate.setTime(currentDate.getTime() + 24 * 60 * 60 * 1000);
              const expires = `expires=${currentDate.toGMTString()}`;
              document.cookie = `siteBanner=shown;${expires}`;
              closeDiv();
            }}
          >
            x
          </button>
        </div>
      </div>
    );
  };

  return (
    <div hidden={bannerHidden}>
      {!!Object.keys(promoData).length && renderBanner()}
    </div>
  );
};

export default CmsBanner;
